import React from 'react';
import { Button, Tooltip } from 'antd';
import { BulbOutlined, BulbFilled, DesktopOutlined } from '@ant-design/icons';
import { useThemeMode } from '../../contexts/ThemeContext';

/**
 * Control de tema minimalista: un solo botón-ícono que cicla al hacer clic.
 * Orden: claro → oscuro → automático → claro…
 * El ícono refleja el modo actual; el Tooltip lo nombra y avisa que se cicla.
 */
const CYCLE = ['light', 'dark', 'auto'];

const META = {
  light: { icon: <BulbOutlined />, label: 'Claro' },
  dark: { icon: <BulbFilled />, label: 'Oscuro' },
  auto: { icon: <DesktopOutlined />, label: 'Automático' },
};

const ThemeControl = () => {
  const { mode, setMode } = useThemeMode();
  const current = META[mode] || META.auto;

  const next = () => {
    const i = CYCLE.indexOf(mode);
    setMode(CYCLE[(i + 1 + CYCLE.length) % CYCLE.length]);
  };

  return (
    <Tooltip title={`Tema: ${current.label} · clic para cambiar`}>
      <Button
        type="text"
        shape="circle"
        aria-label={`Tema: ${current.label}. Clic para cambiar`}
        icon={current.icon}
        onClick={next}
      />
    </Tooltip>
  );
};

export default ThemeControl;
